import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { PortfolioService } from "../../pages/portfolio/portfolio.service";
import { PortfolioModel } from "../../shared/models/portfolio.model";
import { MaterialModule } from "src/app/app.materials";
import { FormsModule } from "@angular/forms";

import { SearchPipe } from "src/app/shared/services/search.pipe";
@Component({
  selector: "app-benchmark-selector",
  templateUrl: "./benchmark-selector.component.html",
  styleUrls: ["./benchmark-selector.component.scss"],
  imports: [MaterialModule, FormsModule, SearchPipe],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class BenchmarkSelectorComponent implements OnInit {
  @Input() showLabel = false;
  @Input() label = "Benchmark";
  @Input() benchmarkPlaceholder = "Select benchmark";
  @Input() selectedBenchmark: any;
  @Input() isFullWidth = false;
  @Output() benchmarkSelect: EventEmitter<any> = new EventEmitter<any>();

  benchmarks: any[] = [];
  currencies: any[] = [];
  commodities: any[] = [];
  portfolios: any[] = [];

  assetGroups = ["Europe", "Asia", "World", "North America", "The Nordics"];

  portfolio = new PortfolioModel({});

  searchText = "";
  benchmarksHidden = false;
  portfoliosHidden = false;
  constructor(private service: PortfolioService) {}

  ngOnInit(): void {
    this.fetchBenchmarks();
    this.getPortfolioList();
    this.checkSelectedBenchmark();
  }

  ngOnChanges(): void {
    this.checkSelectedBenchmark();
  }

  async fetchBenchmarks() {
    var resp = await this.service.getBenchmarks();
    resp.subscribe((res: any) => {
      if (res) {
        this.benchmarks = res;
        // filter out macro data
        this.benchmarks = this.benchmarks.filter((b: any) =>
          this.assetGroups.includes(b.group),
        );
        this.checkSelectedBenchmark();
      }
    });
  }

  checkSelectedBenchmark() {
    if (this.selectedBenchmark && this.selectedBenchmark.id) {
      // Fix benchmark name display
      if (this.selectedBenchmark.index_name_full) {
        this.selectedBenchmark.name_full =
          this.selectedBenchmark.index_name_full;
      }
    } else if (
      this.selectedBenchmark &&
      typeof this.selectedBenchmark == "string" &&
      this.benchmarks.length
    ) {
      // benchamrk string selected, find the actual benchmark object
      this.benchmarks.forEach((group) => {
        group.items.forEach((benchmark: any) => {
          if (benchmark.name == this.selectedBenchmark) {
            this.selectedBenchmark = benchmark;
            return;
          }
        });
      });
    }
  }

  getPortfolioList() {
    if (this.service.portfolioLists) {
      return this.skipSelectedPortfolioFromList();
    }
    this.service.getItems().subscribe((resp: any) => {
      if (resp.error) {
        this.service.notificationService.open(resp.error);
      }
      resp = this.service.extractPortfolioData(resp);
      let lists = resp;

      // merge private and shared by me lists
      lists.private = [...lists.private, ...lists.shared_by_me];
      this.service.portfolioLists = lists;
      return this.skipSelectedPortfolioFromList();
    });
  }

  skipSelectedPortfolioFromList() {
    let portfolios = [];
    Object.entries(this.service.portfolioLists).map(
      ([key, values]: [string, any]) => {
        values.map((p: any) => {
          if (p.id != this.portfolio.id) {
            portfolios.push(p);
          }
        });
      },
    );
    portfolios.sort((a, b) =>
      a.name.toLowerCase() > b.name.toLowerCase()
        ? 1
        : b.name.toLowerCase() > a.name.toLowerCase()
          ? -1
          : 0,
    );

    this.portfolios = portfolios;
  }
  onBenchmarkSelect(selected) {
    this.selectedBenchmark = selected;
    this.benchmarkSelect.emit(selected);
  }

  onSearchChange() {
    this.benchmarks = this.benchmarks.map((p) => {
      p.hidden = !p.items.filter((f) => !f.hidden).length;
      return p;
    });
    this.benchmarksHidden = !this.benchmarks.filter((p) => !p.hidden).length;
    this.portfoliosHidden = !this.portfolios.filter((p) => !p.hidden).length;
  }

  resetSearch() {
    this.searchText = "";
    this.benchmarksHidden = false;
    this.portfoliosHidden = false;
    this.benchmarks = this.benchmarks.map((p) => {
      p.hidden = false;
      p.items = p.items.map((b) => {
        b.hidden = false;
        return b;
      });
      return p;
    });
    this.portfolios = this.portfolios.map((p) => {
      p.hidden = false;
      return p;
    });
  }

  removeBenchmark() {
    this.selectedBenchmark = "";
    this.benchmarkSelect.emit(this.selectedBenchmark);
  }
}
